import React from "react";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import TimePicker from "@mui/lab/TimePicker";

function FieldTime(props) {
  //   const [value, setValue] = React.useState(null);
  const {
    label = "",
    className = "",
    value = null,
    onChange,
    error = false,
    errorMsg = `invalid ${props.label}`
  } = props;
  return (
    <div className={`width100 muiTextTimeField ${className}`}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <TimePicker
          label={label}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField size="small" {...params} />}
        />
      </LocalizationProvider>
      {/* <img src="/mtsomsmerge/Assets/Images/time.png" alt="clock" /> */}
    </div>
  );
}

export default FieldTime;
